export default {
  setNotification (context, payload) {
    context.commit('setNotification', payload)
  }
}
